"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Close_1 = tslib_1.__importDefault(require("@material-ui/icons/Close"));
var core_1 = require("@material-ui/core");
var ModalHeader_styles_1 = require("./ModalHeader.styles");
var ModalHeader = function (_a) {
    var children = _a.children, onClickClose = _a.onClickClose;
    var classes = (0, ModalHeader_styles_1.useModalHeaderStyles)();
    return (React.createElement("div", { className: classes.main, "data-signa": "modal-header-container" },
        React.createElement("div", { className: classes.content }, children),
        onClickClose && (React.createElement(core_1.IconButton, { "data-signa": "modal-header-close-button", size: 'medium', "aria-label": "close", classes: { root: classes.icon }, onClick: onClickClose },
            React.createElement(Close_1.default, null)))));
};
exports.ModalHeader = ModalHeader;
